// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"fc1edce7","142":"1c54d756","232":"d8a8643d","308":"eca89f16","400":"274ffb45","915":"1306d57a"}[chunkId] + ".chunk.js";
};